// Dummy quiz content shared by all Layout variants.
// Replace with real survey data once the productive pipeline is wired in.

const frequencyOptions = [
  { value: 0, label: 'weniger als 1x pro Woche', shortLabel: 'weniger als 1×', compactLabel: '< 1×' },
  { value: 1, label: '1 bis 2 mal pro Woche', shortLabel: '1–2× pro Woche', compactLabel: '1–2×' },
  { value: 2, label: '3 bis 4 mal pro Woche', shortLabel: '3–4× pro Woche', compactLabel: '3–4×' },
  { value: 3, label: '5 mal oder mehr pro Woche', shortLabel: '5+× pro Woche', compactLabel: '5+×' },
];

const glassesOptions = [
  { value: 0, label: 'weniger als 1 Glas', shortLabel: 'weniger als 1 Glas', compactLabel: '< 1' },
  { value: 1, label: '1 bis 3 Gläser', shortLabel: '1–3 Gläser', compactLabel: '1–3' },
  { value: 2, label: '4 bis 6 Gläser', shortLabel: '4–6 Gläser', compactLabel: '4–6' },
  { value: 3, label: '7 oder mehr Gläser', shortLabel: '7+ Gläser', compactLabel: '7+' },
];

export const sections = [
  {
    id: 'gemuese',
    label: 'Gemüse',
    prompt: 'Wie oft pro Woche isst du normalerweise diese Gemüsesorten?',
  },
  {
    id: 'obst',
    label: 'Früchte',
    prompt: 'Wie oft pro Woche isst du normalerweise diese Früchte?',
  },
  {
    id: 'getranke',
    label: 'Getränke',
    prompt: 'Wie oft trinkst du normalerweise diese Getränke?',
  },
];

export const questions = [
  // Gemüse
  {
    id: 1,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Tomaten / Tomatensauce',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    tooltip:
      'Frische Tomaten und Tomatensauce als Hauptbestandteil. Kleine Mengen Ketchup oder Tomatensauce auf der Pizza zählen nicht separat.',
    options: frequencyOptions,
  },
  {
    id: 2,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Karotten',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 3,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Zwiebeln, Lauch',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    tooltip: 'Kleine Mengen als Würze (z.B. Zwiebel im Sugo) zählen nicht als Portion.',
    options: frequencyOptions,
  },
  {
    id: 4,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Blattsalat, Spinat',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 5,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Gurke, Zucchetti',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 6,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Peperoni, Aubergine',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    tooltip: 'Peperoni bedeutet hier Gemüsepaprika (nicht Chili).',
    options: frequencyOptions,
  },
  {
    id: 7,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Broccoli',
    prompt: 'Wie oft pro Woche isst du diesen normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 8,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Rande',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    tooltip: 'Rande = Randen = Rote Bete = Betterave = Barbabietola.',
    options: frequencyOptions,
  },
  {
    id: 9,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Pilze',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 10,
    sectionId: 'gemuese',
    type: 'frequency',
    title: 'Kohl, Wirsing',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },

  // Früchte
  {
    id: 11,
    sectionId: 'obst',
    type: 'frequency',
    title: 'Äpfel und Birnen',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 12,
    sectionId: 'obst',
    type: 'frequency',
    title: 'Beeren (Erdbeeren, Heidelbeeren …)',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 13,
    sectionId: 'obst',
    type: 'frequency',
    title: 'Bananen',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 14,
    sectionId: 'obst',
    type: 'frequency',
    title: 'Zitrusfrüchte (Orangen, Mandarinen)',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 15,
    sectionId: 'obst',
    type: 'frequency',
    title: 'Trauben',
    prompt: 'Wie oft pro Woche isst du diese normalerweise?',
    options: frequencyOptions,
  },

  // Getränke
  {
    id: 16,
    sectionId: 'getranke',
    type: 'glasses',
    title: 'Wasser',
    prompt: 'Wie viele Gläser Wasser trinkst du pro Tag?',
    options: glassesOptions,
  },
  {
    id: 17,
    sectionId: 'getranke',
    type: 'frequency',
    title: 'Süssgetränke (Cola, Limonaden)',
    prompt: 'Wie oft pro Woche trinkst du diese normalerweise?',
    options: frequencyOptions,
  },
  {
    id: 18,
    sectionId: 'getranke',
    type: 'frequency',
    title: 'Kaffee',
    prompt: 'Wie oft pro Tag trinkst du Kaffee?',
    options: frequencyOptions,
  },
  {
    id: 19,
    sectionId: 'getranke',
    type: 'frequency',
    title: 'Tee',
    prompt: 'Wie oft pro Tag trinkst du Tee?',
    options: frequencyOptions,
  },
  {
    id: 20,
    sectionId: 'getranke',
    type: 'frequency',
    title: 'Säfte (Frucht-, Gemüsesaft)',
    prompt: 'Wie oft pro Woche trinkst du diese normalerweise?',
    options: frequencyOptions,
  },
];

// Headline portion questions (used by Vanilla D and any layout that supports
// numeric stepper input).
export const portionQuestions = [
  {
    id: 'p1',
    sectionId: 'gemuese',
    type: 'portion',
    title: 'Wie viele Portionen Gemüse oder Salat isst du pro Tag?',
    prompt: 'Eine Portion entspricht etwa einer Handvoll oder 120 g.',
    unit: 'Portion',
    unitPlural: 'Portionen',
    initial: 2,
    min: 0,
    max: 10,
  },
  {
    id: 'p19',
    sectionId: 'obst',
    type: 'portion',
    title: 'Wie viele Portionen Früchte isst du pro Tag?',
    prompt: 'Eine Portion entspricht etwa einer Handvoll oder 120 g.',
    unit: 'Portion',
    unitPlural: 'Portionen',
    initial: 1,
    min: 0,
    max: 10,
  },
  {
    id: 'p65',
    sectionId: 'getranke',
    type: 'portion',
    title: 'Wie viele Gläser Wasser trinkst du pro Tag?',
    prompt: 'Ein Glas entspricht etwa 2 dl.',
    unit: 'Glas',
    unitPlural: 'Gläser',
    initial: 5,
    min: 0,
    max: 15,
  },
];

// Reference list shown by the "Was ist eine Portion?" primer overlay.
export const portionPrimer = [
  { amount: '120 g', item: 'Gemüse oder Früchte', note: 'etwa eine Handvoll' },
  { amount: '2 dl', item: 'Milch oder Sojadrink', note: 'ein normales Trinkglas' },
  { amount: '30 g', item: 'Käse', note: 'etwa zwei Scheiben oder ein dickes Stück' },
  { amount: '25–30 g', item: 'Nüsse', note: 'eine kleine Handvoll' },
  { amount: '150–200 g', item: 'Joghurt', note: 'ein normaler Becher' },
  { amount: '2 dl', item: 'Wasser, Tee oder Kaffee', note: 'ein normales Glas oder eine Tasse' },
];
